<template>
  <div>
	<h5>Mapeo de Api</h5>
	<div class="d-flex flex-column w-100 mt-1">
		<div class="row no-gutters card card-body mb-1" v-for="(item, index) in arrayServiceTypes" :key="index">
			<div class="col-12 mb-2">
				<div class="d-flex h-100">
					<div class="flex-grow-1 text-primary font-weight-bold">
						{{item.name}}
					</div>
					<!-- <label class=" text-primary  mr-2">ID: {{item.id}}</label> -->

					<b-button  @click="(event) => editModel(item)" type="button" size="sm" class="mr-1" variant="info">
                        <md-icon icon="edit" />
                    </b-button>
				</div>
			</div>
			<div class="pr-4">
				<table class="table table-striped ml-4 table-sm" >
				<thead>
						<tr>
							<th class="col-9">Nombre</th>
							<th class="col-1">Iata</th>
							<th class="col-1">MinPax</th>
							<th class="col-1">MaxPax</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(itemService, indexService) in item.services" :key="indexService">
							<td>{{itemService.name}}</td>
							<td>{{itemService.iata?itemService.iata:'--'}}</td>
							<td>{{itemService.minPax?itemService.minPax:'--'}}</td>
							<td>{{itemService.maxPax?itemService.maxPax:'--'}}</td>
						</tr>
					</tbody>

			</table>
			</div>
		</div>
	</div>
	<FormModel ref="refFormModel" @successCallback="successCallback"></FormModel>
  </div>
</template>

<script>
import FormModel from './SingleForm.vue'

export default {
	props:{
		modelId: [String, Number],
	},
	components:{
		FormModel
	},
	data(){
		return{
			arrayServiceTypes:null,
		}
	},
	mounted(){
		this.getMappingName();
	},
	methods:{
		successCallback(){
			this.getMappingName();
		},
		editModel(id) {
			this.$refs.refFormModel.show();
			this.$refs.refFormModel.setModel(id.id, id.name);
		},
		getMappingName(){
			let rParams = {
				url: `/mappings/service-types/`+this.modelId ,
				method: "get",
			};
			this.$root.api
				.request(rParams)
				.then((res) => {
					this.arrayServiceTypes =  res.data.data;
					// this.arrayMappingName = res.data.data;
				})
				.catch(()=>{
					this.$root.handleRequestError;
				});
		},
	}
}
</script>

<style scoped>
.u\:text-size-2{
	font-size:  0.73rem;
}
.u\:border-service{
	border-top: solid 1px rgb(213, 213, 213);
}
</style>
